module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_charging_solid.a2378b9e.svg";